/**
 * vue add i18n
 *
 */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ko from '../locales/ko.json';
import en from '../locales/en.json';
import { resolveInitialLocale } from '../utils/localeUtils';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: resolveInitialLocale(),
  fallbackLocale: 'en',
  messages: {
    ko,
    en
  }
});

export default i18n;
